export const environment = {
    configuration: 'testnet',
    version: '1.0.0',
    explorer_url: 'https://suiscan.xyz/testnet',
    twitter_url: 'https://x.com/kyovylabs',
    discord_url: 'https://discord.gg/mc7T9k9RYp',
    page_size: 10,
    graphql: {
        default: 'https://sui-testnet.mystenlabs.com/graphql',
        foundation: 'https://sui-testnet.mystenlabs.com/graphql',
    },
    jsonrpc: {
        default: 'https://fullnode.testnet.sui.io',
        foundation: 'https://fullnode.testnet.sui.io',
        suiscan: 'https://rpc-testnet.suiscan.xyz',
        publicnode: 'https://sui-testnet-rpc.publicnode.com',
        blastapi: 'https://sui-testnet.public.blastapi.io',
    },
    config: {
        original_package_id: "0xffdcb4608c35b6b2305e59977af501e1f41336655233990765198ffba984f4a8",
        latest_package_id: "0xffdcb4608c35b6b2305e59977af501e1f41336655233990765198ffba984f4a8",
        upgrade_cap_id: "0x5b522448860dc031c5b4a9b632b068eadb53a6ade4cf70d3de7bc7f80e42b50e",
        treasury_cap_id: "0xb0f6cb6b8eace7f31f2e8d520e2f954590a627c72f1ef85285804109483a47b7",
        versions: [
            "0xffdcb4608c35b6b2305e59977af501e1f41336655233990765198ffba984f4a8"
        ],
        alpha: {
            id: "0x117860358f68e6e645cda29652496a80e609bf34bb89912650c8a9fc5b307f75",
            version: 1,
            admin: "0x5e9d59774159abae9e3d11c82760b70c709b78b956e31f2d7e65f2f39702801d",
            bag_id: "0x4968b2bb8478c439ef112b17660c2677f2253d7ebc72fdbbdf59fa034d759216",
            state_storage_id: "0x8d94ffab0febe04f573b896df9b790f615de8b50719c62a782f4f7c06d80981f",
            state_storage_local_id: "0x6946b003645aa4235701802ddc94c602060ef215d129e6924f193dfa38d7791a",
            wheel_histogram_id: "0x5cb457a60a688427da8246ed2599c994f78b3e0c6318f4e7c64db0964cf1244c",
            tidal_rates_id: "0x4fbf9438c483d2c60175bacb57d338cc7397b92b74630679e11a551f45bbc2ac",
            tidal_holders_id: "0xc0ceca1a8d7296d55ca6fc902a87ac18843030e8113fc2fade06ae9a7dc18b0a"
        }
    }
};
